import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import { TemplateStatusBadge } from '~/components/Badges'

const TemplateStatusCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  return value ? <TemplateStatusBadge value={value} /> : <div />
}

export default TemplateStatusCellRenderer
